import { Box, Link, Typography } from '@mui/material';
import { Link as RouterLink } from 'react-router-dom';

export function LegalFooter() {
  return (
    <Box
      component="footer"
      sx={{
        mt: 'auto',
        py: 1.75,
        px: 2,
        borderTop: '1px solid',
        borderColor: 'divider',
        bgcolor: 'rgba(255,255,255,0.6)',
      }}
    >
      <Typography
        component="nav"
        variant="caption"
        sx={{
          display: 'flex',
          flexWrap: 'wrap',
          alignItems: 'center',
          justifyContent: 'center',
          gap: 1,
          color: 'text.secondary',
          fontSize: '0.75rem',
        }}
        aria-label="Rechtliches"
      >
        <Link component={RouterLink} to="/agb" color="inherit" sx={{ fontWeight: 600 }}>
          AGB
        </Link>
        <Typography component="span" variant="caption" color="text.disabled">
          ·
        </Typography>
        <Link component={RouterLink} to="/datenschutz" color="inherit" sx={{ fontWeight: 600 }}>
          Datenschutz
        </Link>
        <Typography component="span" variant="caption" color="text.disabled">
          ·
        </Typography>
        <Link component={RouterLink} to="/impressum" color="inherit" sx={{ fontWeight: 600 }}>
          Impressum
        </Link>
        <Typography component="span" variant="caption" color="text.disabled">
          ·
        </Typography>
        <Link component={RouterLink} to="/kuendigung" color="inherit" sx={{ fontWeight: 600 }}>
          Verträge hier kündigen
        </Link>
        <Typography component="span" variant="caption" color="text.disabled">
          ·
        </Typography>
        <Link component={RouterLink} to="/widerruf" color="inherit" sx={{ fontWeight: 600 }}>
          Vertrag widerrufen
        </Link>
        <Typography component="span" variant="caption" color="text.disabled">
          ·
        </Typography>
        <Typography component="span" variant="caption" color="text.disabled" sx={{ fontSize: '0.65rem' }}>
          v{import.meta.env.VITE_APP_VERSION}
        </Typography>
      </Typography>
    </Box>
  );
}
